export const WorkData = [
    // {
    //     company :"Self Employed",
    //     designation: "Frontend Engineer",
    //     dateJoining:"30 April 2023",
    //     dateEnd:"Present",
    //     companyLogo: require("../../assets/company.png"),
    //     work: "Developed multiple website using html css js, and react, redux like:- E-Commerce and more.. ",
    //     Tech: ["React.js","JavaScript","MERN STACK", "CSS"],
    // },
    {
        company :"Self Employed",
        designation: "Learn and Develop",
        dateJoining:"30 April 2023",
        dateEnd:"Present",
        companyLogo: require("../../assets/company.png"),
        work: "Working on Own Protfolio and Zomato clone UI.",
        work2:"Mimics the overall structure of Amazon's website.",
        work3: "Cloning Razor Pay UI.",
        work4: "Develop a NewViews Web Apps, in which Implement News API Integration.",
        Tech: ["React.js","CSS","Tailwind CSS", "Vite", "API"],
    },
    {
        company :"Wopno Techon",
        designation: "Software Engineer, intern",
        dateJoining:"04 February 2023",
        dateEnd:"30 April 2023",
        companyLogo: require("../../assets/company.png"),
        work: "Developed an admin Dashboard UI, showing order status, transactions, sales, and expenses for Seroboard  Designed and Developed the Branded Website to increase its Reach and strong Marketing. Developed  Websites using WordPress ( like:-saveanyvehicle.com, fabley.in)",
        Tech: ["React.js", "WordPress", "css"]
    },
]